module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/complaint_new_banner.d8f24dab.png";